module.exports = __webpack_public_path__ + "static/img/title.24f182b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/title.png
// module id = xnXZ
// module chunks = 7